<div class="apt-overlay-no-rows" data-test-selector="apt-overlay-no-rows">
  <span *ngIf="noRowsMessage$">{{ noRowsMessage$ | async }}</span>
  <span *ngIf="!noRowsMessage$">{{ noRowsMessageFunc() }}</span>
</div>
